export const VerticalDoubleArrowIcon = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      width="12"
      height="27"
      viewBox="0 0 12 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.56825 22.0403V4.39162L2.18138 6.732C1.92663 6.99275 1.62825 7.12312 1.28625 7.12312C0.944501 7.12312 0.646126 6.99575 0.391126 6.741C0.130376 6.486 0 6.18762 0 5.84587C0 5.50387 0.130376 5.2025 0.391126 4.94175L4.94175 0.391125C5.07875 0.254125 5.22175 0.154624 5.37075 0.0926239C5.5195 0.0308739 5.67788 0 5.84588 0C6.01388 0 6.17225 0.0308739 6.321 0.0926239C6.47 0.154624 6.613 0.254125 6.75 0.391125L11.3096 4.95075C11.5644 5.2055 11.6918 5.50537 11.6918 5.85037C11.6918 6.19512 11.5614 6.495 11.3006 6.75C11.0456 7.00475 10.741 7.13213 10.3868 7.13213C10.0323 7.13213 9.73063 7.00475 9.48188 6.75L7.1235 4.39162V22.0403L9.51938 19.6995C9.77413 19.4637 10.0725 19.3411 10.4145 19.3316C10.7563 19.3221 11.0546 19.4447 11.3096 19.6995C11.5644 19.9545 11.6918 20.2529 11.6918 20.5946C11.6918 20.9366 11.5644 21.235 11.3096 21.4897L6.75 26.0494C6.613 26.1864 6.47 26.2859 6.321 26.3479C6.17225 26.4096 6.01388 26.4405 5.84588 26.4405C5.67788 26.4405 5.5195 26.4096 5.37075 26.3479C5.22175 26.2859 5.07875 26.1864 4.94175 26.0494L0.391126 21.4897C0.136376 21.235 0.00900078 20.9366 0.00900078 20.5946C0.00900078 20.2529 0.136376 19.9545 0.391126 19.6995C0.646126 19.4387 0.943001 19.3146 1.28175 19.3271C1.62075 19.3396 1.92063 19.4637 2.18138 19.6995L4.56825 22.0403Z"
        fill="currentColor"
      />
    </svg>
  );
};
